import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as shareActions from '../../../actions/shareActions';
import IconWithText from '../Icons/IconWithText';
import Dropdown from '../Dropdowns/Dropdown';
import SocialShare from './SocialShare';
/* global FB */ // Prevent 'FB is undefined' ESLint error

class ShareDropdown extends Component {
  componentDidMount() {
    // Because some pages have multiple identical share buttons (e.g. content pages which have one in the header and one after the header)
    // we only want to get the counts once per page, not once per share button
    if (this.props.shareCount.loaded === false) {
      // this.props.actions.getShareCounts();
    }
  }

  facebookShare = (url) => {
    FB.ui({
      method: 'share',
      display: 'popup',
      href: url,
    }, function() {});
  }

  twitterShare = (url) => {
    const link = `https://twitter.com/intent/tweet?via=CoachingManual&amp;url=${url}&amp;text=${this.props.title}`;
    window.open(link, 'newwindow', 'width=600, height=500');
    return false;
  }

  socialShareClick = (type) => {
    const url = window.location.href;
    switch (type) {
      case 'facebook':
        this.facebookShare(url);
        break;
      case 'twitter':
        this.twitterShare(url);
        break;
      // no default
    }
  }

  render() {
    const { shareCount } = this.props;

    const shareBtn = <div className="btn"><IconWithText name="share" size="m" fill="white">Share</IconWithText></div>;

    return (
      <div className="share-btn-container">
        <Dropdown label={shareBtn} position="right" size="l" noArrow>
          <SocialShare onClick={this.socialShareClick} shareCount={shareCount} />
        </Dropdown>
      </div>
    );
  }
}

ShareDropdown.propTypes = {
  title: PropTypes.string,
  actions: PropTypes.object.isRequired,
  shareCount: PropTypes.object,
};

function mapStateToProps(state) {
  return {
    shareCount: state.shareCount,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(Object.assign({}, shareActions), dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(ShareDropdown);



// WEBPACK FOOTER //
// ./library/app/components/Global/Sharing/ShareDropdown.js